module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_android_04-900-c5bb1a1abf7b687b0ccd7663ac215f1b.png";